import ExternalLinksList from 'components/externalLinks/ExternalLinksList';
import { codesLinks, getDownloadLinks, getPropertyLinks } from 'utils/propertyLinks';
import Dropdown from 'components/Dropdown';
import AcrisLink from 'components/externalLinks/AcrisLink';

import './LinkDropdownButton.css';

const HPD_ONLINE_BUILDING_URL = 'https://hpdonline.nyc.gov/hpdonline/building';
// FDNY's report form; the reader enters the BIN there, so the URL has no property in it
const FDNY_BUILDING_PROFILE_URL =
	'https://fires.fdnycloud.org/CitizenAccess/Report/ReportParameter.aspx?module=&reportID=1423&reportType=LINK_REPORT_LIST';


const LinkList = ({ links, onLinkClick }) => {
	return (
		<div className="quick-links-items-container">
			{Object.entries(links).map(([label, url]) => (
				<div key={`${label}`} className="quick-link-row">
					<a
						href={url}
						target="_blank"
						rel="noreferrer"
						className="quick-link-item-btn"
						onClick={onLinkClick}
					>
						<span className="quick-link-title">{label}</span>
						<i className="bi bi-box-arrow-up-right quick-link-arrow-icon" />
					</a>
				</div>
			))}
		</div>
	);
};



// Opens externally what the old document icons in the property info card opened; icons with no data for the property stay hidden
const getPropertyDocumentLinks = (property) => {
	const links = {};
	if (property?.bin) {
		links['Certificate of Occupancy'] = getDownloadLinks(property)['Certificate of Occupancy'];
	}
	links['FDNY Building Information Profile'] = FDNY_BUILDING_PROFILE_URL;
	if (property?.hpd_building_id) {
		links['I-Card'] = `${HPD_ONLINE_BUILDING_URL}/${property.hpd_building_id}/overview`;
	}
	links['Landmark Designation Report'] = `https://nyclpc.maps.arcgis.com/apps/webappviewer/index.html?id=93a88691cace4067828b1eede432022b&marker=${property?.long},${property?.lat},,,,&markertemplate={"title":"","longitude":${property?.long},"latitude":${property?.lat},"isIncludeShareUrl":true}&level=18`;
	return links;
};

const LinkDropdownButton = ({ listName, property, iconOnly }) => {
	if (!listName) {
		return null;
	}

	let menuChild = null;
	let buttonText = null;
	let buttonIcon = null;
	let hideChevron = false;


	const iconLinks = (
		<div className="quick-links-header">
			<a
				href="https://a836-pts-access.nyc.gov/care/search/commonsearch.aspx?mode=address"
				target="_blank"
				rel="noreferrer"
				className="quick-links-header-pill"
				title="NYC Department of Finance Property Search"
			>
				<img className="quick-links-dof-logo" src="/nyc_finance_logo.png" alt="NYC Department of Finance" />
				<span>DOF Portal</span>
			</a>
			<div className="quick-links-acris-pill-wrapper">
				<AcrisLink buttonClass="quick-links-header-pill acris-pill">
					<span className="acris-pill-badge">ACRIS</span>
					<span>Records</span>
				</AcrisLink>
			</div>
		</div>
	);

	// DOB BIS, DOB NOW and ZoLA get their own pill row above the alphabetical
	// list, same treatment as the DOF/ACRIS row -- pulled straight out of
	// getPropertyLinks() instead of re-deriving these URLs here, so they can't
	// drift from the per-property link data everywhere else reads from.
	const dobZolaLinksData = getPropertyLinks(property);
	const dobZolaLinks = (
		<div className="quick-links-header">
			<a
				href={dobZolaLinksData['DOB BIS']}
				target="_blank"
				rel="noreferrer"
				className="quick-links-header-pill"
				title="DOB BIS"
			>
				<span>DOB BIS</span>
			</a>
			<a
				href={dobZolaLinksData['DOB NOW']}
				target="_blank"
				rel="noreferrer"
				className="quick-links-header-pill"
				title="DOB NOW"
			>
				<span>DOB NOW</span>
			</a>
			<a
				href={dobZolaLinksData['ZoLa Map']}
				target="_blank"
				rel="noreferrer"
				className="quick-links-header-pill"
				title="ZoLA"
			>
				<span>ZoLA</span>
			</a>
		</div>
	);


	if (listName === 'propertyDocuments') {
		menuChild = ({ closeDropdown }) => (
			<LinkList links={getPropertyDocumentLinks(property)} onLinkClick={closeDropdown} />
		);
		buttonText = 'Records';
		if (iconOnly) {
			buttonText = null;
			buttonIcon = 'bi bi-file-earmark';
			hideChevron = true;
		}
	} else if (listName === 'quickLinks') {
		menuChild = ({ closeDropdown }) => (
			<div>
				{iconLinks}
				{dobZolaLinks}
				<ExternalLinksList listName={'quickLinksV2'} onLinkClick={closeDropdown} />
			</div>
		);
		buttonText = 'Quick Links';
		if (iconOnly) {
			buttonText = null;
			buttonIcon = 'bi bi-link';
			hideChevron = true
		}
	} else if (listName === 'codes') {
		menuChild = <LinkList links={codesLinks} />;
		buttonText = 'Codes';
		if (iconOnly) {
			buttonText = null;
			buttonIcon = 'bi bi-file-earmark-text';
			hideChevron = true
		}
	}

	return (
		<Dropdown
			buttonText={buttonText}
			buttonIcon={buttonIcon}
			menuChild={menuChild}
			className="overview-dropdown-links"
			buttonClass="btn-sm"
			menuClass="overview-dropdown-links-menu"
			hideChevron={hideChevron}
		/>
	);


}

export default LinkDropdownButton;
